import axios from '../utils/index';

const chatApi = {
    async syncSupportChannels() {
        return axios.post(`/chat/sync-support-channels`);
    },
    async getStreamChatSession() {
        return axios.get(`/chat/session`);
    },
    // Ensures the target customer/tasker exists in GetStream before opening a DM,
    // so admins can message users who have not logged in since the migration.
    async ensureChatUser(userId: string, type: string) {
        return axios.post(`/chat/ensure-user`, { userId: String(userId), type });
    },
};

export default chatApi;
